import React, { use, useEffect, useReducer, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxConfig from '../../../util/remote/ajaxConfig';
import { useTheme } from '../../../DataStore/ThemeContext';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    "company_name":'',
    "telephone":'',
    "address":'',
    "email_address":'',
    "motto":'',
    "short_name":'',
    "website":'',
}

const EditProfile = ({profile}) => {

    const [currentNotify, setNotify] = useState(null);
    const {getCompanyProfile} = useConfig();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { setSystemFunction } = useTheme();

   useEffect(()=>{
       if(profile){
           dispatch({type: 'company_name', value: profile.client_name});
            dispatch({type: 'telephone', value: profile.telephone});
            dispatch({type: 'address', value: profile.address});
            dispatch({type: 'email_address', value: profile.email_address});
            dispatch({type: 'motto', value: profile.motto});
            dispatch({type: 'short_name', value: profile.short_name});
            dispatch({type: 'website', value: profile.website || ''});
        }
    }, [profile]);

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    useEffect(()=>{
        setSystemFunction(() => handleSave);
        return () => setSystemFunction(() => {});
    }, [state]);

    const handleSave = async () =>{
        const data = {
            client_name: state.company_name,
            telephone: state.telephone,
            address: state.address,
            email_address: state.email_address,
            motto: state.motto,
            short_name: state.short_name,
            website: state.website
        };
        const server_response = await ajaxConfig.updateClientProfile(data);
        if(server_response.status === "OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            getCompanyProfile(true); // Refresh the company profile data
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);
        }
    }


    const handleFormChange=(event)=>{
        const { name, value } = event.target;
        dispatch({type: name, value: value});
    }
  

    return (
        <>

            <CallOut 
                title="Company Identity"
                description="Manage your core business details and branding. The information provided here is used to generate professional invoices, statements, and official reports."
             />
             <div className="mb-4 mt-4 animate__animated animate__fadeIn">{currentNotify}</div>
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

               <TextInput
                    type="text"
                    label="Company Name"
                    placeholder="Company Name"
                    leftIcon="fa fa-info"
                    value={state.company_name}
                    name="company_name"
                    onChange={handleFormChange} 
                    required
                    wrap
                    />

                <TextInput
                    type="text"
                    label="Company Address"
                    placeholder="Company Address"
                    leftIcon="fa fa-map-pin"
                    value={state.address}
                    name="address"
                    onChange={handleFormChange} 
                    required
                    wrap
                    />


               <TextInput
                    type="text"
                    label="Company Motto"
                    placeholder="Company Motto"
                    leftIcon="fa fa-info"
                    value={state.motto}
                    name="motto"
                    onChange={handleFormChange} 
                    required
                    wrap
                    />


               <TextInput
                    type="text"
                    label="Telephone"
                    placeholder="Telephone"
                    leftIcon="fa fa-phone"
                    value={state.telephone}
                    name="telephone"
                    onChange={handleFormChange} 
                    required
                    wrap
                    />


                <TextInput
                    type="text"
                    label="Email Address"
                    placeholder="Email address"
                    leftIcon="fa fa-envelope"
                    value={state.email_address}
                    name="email_address"
                    onChange={handleFormChange} 
                    required
                    wrap
                    />
               
    
               <TextInput
                    type="text"
                    label="Website"
                    placeholder="Website"
                    leftIcon="fa fa-globe"
                    value={state.website}
                    name="website"
                    onChange={handleFormChange}
                    wrap 
                    />
                <TextInput
                    type="text"
                    label="Short Name"
                    placeholder="Short Name"
                    leftIcon="fa fa-star"
                    value={state.short_name}
                    name="short_name"
                    onChange={handleFormChange} 
                    required
                    wrap
                    />

            </form> 


        </>
    );
};

export default EditProfile;